import { useMutation } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";

interface DeviceTokenData {
  userId: number;
  subscriberId: string;
}

interface DeviceTokenResponse {
  success: boolean;
  message: string;
}

export const useDeviceTokenMutation = () => {
  return useMutation({
    mutationFn: ({ userId, subscriberId }: DeviceTokenData) =>
      apiClient.post<DeviceTokenResponse>(Routes.ONE_SIGNAL_USER_INFO(userId), {
        device_token: {
          token: subscriberId,
          device_type: "native",
        },
      }),
  });
};

export const useDeviceTokenDeleteMutation = () => {
  return useMutation({
    mutationFn: ({ userId, subscriberId }: DeviceTokenData) =>
      apiClient.delete<DeviceTokenResponse>(
        Routes.ONE_SIGNAL_DELETE_USER_INFO(userId, subscriberId),
        {
          data: {
            device_token: {
              token: subscriberId,
              device_type: "native",
            },
          },
        }
      ),
  });
};
